"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.X = exports.Warning = void 0;
/* eslint-disable @typescript-eslint/ban-ts-comment */
var react_1 = __importDefault(require("react"));
var Warning = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 44 : _b, _c = _a.width, width = _c === void 0 ? 44 : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? 'none' : _d, _e = _a.borderColor, borderColor = _e === void 0 ? '#FF9C1E' : _e, _f = _a.strokeColor, strokeColor = _f === void 0 ? '#FF9C1E' : _f;
    return (react_1.default.createElement("svg", { width: height, height: width, viewBox: "0 0 24 24", 
        //@ts-ignore
        fill: backgroundColor },
        react_1.default.createElement("path", { d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 8v4", stroke: borderColor, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M12 8V12", stroke: strokeColor, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("circle", { cx: 12, cy: 16, r: 1, fill: strokeColor })));
};
exports.Warning = Warning;
var X = function () {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: "icon icon-tabler icon-tabler-x", width: 24, height: 24, viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", 
        // @ts-ignore
        fill: "none", strokeLinecap: "round", strokeLinejoin: "round" },
        react_1.default.createElement("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
        react_1.default.createElement("path", { d: "M18 6l-12 12" }),
        react_1.default.createElement("path", { d: "M6 6l12 12" })));
};
exports.X = X;
